<div class="modal-header">
    <h4 class="modal-title">Ordner auswählen</h4>
    <button
        type="button"
        class="btn btn-circle btn-sm btn-ghost element-cancel"
        [attr.aria-label]="'a11y-close' | translate"
        (click)="modalRef.hide()"
    ></button>
</div>

<div class="modal-body">
    <div class="d-flex align-items-center mb-2">
        <p class="flex-1 mb-0">Alle Vorlagen</p>
        <button
            type="button"
            class="btn btn-circle btn-sm btn-ghost element-plus"
            [attr.aria-label]="'a11y-add-drive' | translate"
            (click)="addDrive()"
        ></button>
    </div>
    <si-tree-view
        class="h-100"
        [items]="treeItems"
        [contextMenuItems]="contextMenuItems"
        (treeItemFolderClicked)="onFolderClicked($event)"
    ></si-tree-view>
</div>
